import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router';

import { ButtonLounge } from 'app/shared/components/common/button/button-louge';
import { useDispatch, useSelector } from 'react-redux';
import { IContactInfo } from 'app/modules/contact/model/contact.model';
import { createContact } from 'app/modules/contact/service';
import { IRootState } from 'app/shared/reducers';
import { getContractDetails } from 'app/modules/contract/service/store/selectors';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { Card, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import TransitionsModal from 'app/shared/components/common/modal/modal';
import './style.scss';

const rescindSourceChoice = props => {
  const { checkItem, resindSelector, dataConf } = props;
  const history = useHistory();
  const [other, setOther] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [textValue, settextValue] = useState('');
  const [motif, setMotif] = useState('');
  const dispatch = useDispatch();
  const contractDetail: any = useSelector<IRootState>(getContractDetails);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const loading: any = useSelector<IRootState>(state => state.contact.loading);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const handleChange = e => {
    settextValue(e.target.value);
  };

  useEffect(() => {
    if (showModal && !loading) {
      history.push({
        pathname: '/contractRescindConfirmation',
      });
    }
  }, [loading]);

  const chnageValue = event => {
    if (event.target.value === 'Autre') {
      setOther(true);
    } else {
      setOther(false);
      setMotif(event.target.value);
    }
  };

  const sendContat = () => {
    if (other && textValue.length < 20) setShowErrorMessage(true);
    else {
      const repMotif = 'Motif de résiliation :';
      let contactInfo: IContactInfo = {};
      contactInfo = {
        ...contactInfo,
        motif: 'SUBSCRIPTION',
        applicationCode: '1',
        description: repMotif.concat(other ? textValue : motif),
        subscriptionNumber: contractDetail?.detailsContrat?.number,
        clientNumber: contractDetail?.contact?.subscription?.subscriber?.number,
        listDocs: [],
        claimNumber: '',
        task: true,
        ksl: true,
      };
      dispatch(createContact(contactInfo));
      setShowModal(true);
    }
  };

  return (
    <div className="h-100">
      <div className="avatar-style">
        <AvatarWithBadge hideButton={false} avatar={avatar} getPreviousStep={checkItem} title={['Pourquoi voulez-vous nous quitter?']} />
      </div>
      <div className="p-3 scroll-y" style={{ height: `calc(100% - 200px)`, overflowY: 'scroll' }}>
        <Card className="w-100">
          <div className="mobile-contract-rescind-confirmation">
            <div className="confirmation-card">
              <FormControl component="fieldset">
                <RadioGroup>
                  <React.Fragment>
                    {Object.keys(dataConf?.params).map(function (item: any, index) {
                      return (
                        <div className="rescind-checkbox d-flex align-items-center w-100 " key={index}>
                          <FormControlLabel
                            value={resindSelector?.contact_form?.resind_checkbox.find(e => e.key === item)?.value}
                            control={
                              <Radio
                                onChange={() => {
                                  chnageValue(event);
                                }}
                              />
                            }
                            label={resindSelector?.contact_form?.resind_checkbox?.find(e => e.key === item)?.label}
                            className="label-style"
                          />
                        </div>
                      );
                    })}
                  </React.Fragment>
                </RadioGroup>
              </FormControl>

              {other && (
                <>
                  {showErrorMessage ? (
                    <TransitionsModal
                      showModal={true}
                      setShowModel={setShowErrorMessage}
                      textBody={'Merci de renseigner au minimum 20 caractères'}
                    />
                  ) : null}
                  <textarea
                    className="text-area-style"
                    placeholder="Merci de préciser la raison pour laquelle vous souhaitez résilier "
                    rows={5}
                    value={textValue}
                    onChange={e => handleChange(e)}
                    maxLength={500}
                  />
                  <div className="text-area-counter">
                    {textValue.length}/{500}
                  </div>
                </>
              )}
            </div>
            <div className="bottom-button">
              <ButtonLounge
                title="Annuler"
                style={'Mobile2 align-self-center large'}
                action={() => {
                  history.push({
                    pathname: '/Contract-engine',
                  });
                }}
              />
              <ButtonLounge
                title="Confirmer"
                style={'Mobile1 align-self-center  large'}
                action={() => {
                  sendContat();
                }}
                loading={loading}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default rescindSourceChoice;
